module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--3-34d9ad8df11b4ed169f7a386051143b7.jpg";